import { api } from "@/config/axiosInstance";
import { env } from "@/config/env";
import {
  EventEntranceFilterDto,
  EventEntrancePaginatedDto,
  UpdateUserForEntranceDto,
  UserForEntranceDto,
} from "@/pages/events/types";
import { LoginAuthenticated } from "@/pages/login/types/login";
import {
  ProfileDataDto,
  UserDataDto,
  UserEmailUpdateDto,
  UserIndexPaginatedDto,
  UserIndexQueryDto,
  UserPasswordUpdateDto,
  UserStoreDto,
} from "@/pages/users/types";

export const useUser = () => {
  const getUsers = ({
    nameOrEmail,
    profileType,
    situation,
    page,
  }: UserIndexQueryDto) => {
    let params = `page=${page}&perPage=${env.per_page}`;

    if (nameOrEmail) {
      params = `${params}&nameOrEmail=${nameOrEmail}`;
    }

    if (profileType) {
      params = `${params}&profileType=${profileType}`;
    }

    if (situation) {
      params = `${params}&situation=${situation}`;
    }

    return api.get<UserIndexPaginatedDto>(`/account/index?${params}`);
  };

  const userStore = (data: UserStoreDto) => {
    return api.post<void>(`/account/create`, data);
  };

  const userSituationUpdate = (id: number, situation: boolean) => {
    return api.patch<void>(`/account/${id}/situation-update`, { situation });
  };

  const userPasswordUpdate = (id: number, data: UserPasswordUpdateDto) => {
    return api.patch<LoginAuthenticated>(
      `/account/${id}/password-update`,
      data
    );
  };

  const userEmailUpdate = (id: number, data: UserEmailUpdateDto) => {
    return api.patch(`/account/${id}/email-update`, data);
  };

  const getProfiles = () => {
    return api.get<ProfileDataDto[]>("profile/index");
  };

  const getUser = (id: number) => {
    return api.get<UserDataDto>(`account/${id}`);
  };

  const userUpdate = (id: number, data: UserStoreDto) => {
    return api.put(`account/${id}`, data);
  };

  const getUserForEntrance = () => {
    return api.get<UserForEntranceDto[]>(`/account/user-for-entrance`);
  };

  const updateUserForEntrance = (
    id: number,
    data: UpdateUserForEntranceDto
  ) => {
    return api.patch<UserForEntranceDto>(`/account/${id}`, data);
  };

  const getUserByEventId = ({
    eventId,
    name,
    email,
    contact,
    profile,
    situation,
    page,
  }: EventEntranceFilterDto) => {
    let params = `page=${page}&perPage=${env.per_page}`;

    if (name) {
      params = `${params}&name=${name}`;
    }
    if (email) {
      params = `${params}&email=${email}`;
    }
    if (contact) {
      params = `${params}&contact=${contact}`;
    }
    if (profile) {
      params = `${params}&profile=${profile}`;
    }
    if (situation !== undefined) {
      params = `${params}&situation=${situation}`;
    }

    return api.get<EventEntrancePaginatedDto>(
      `/account/account-for-reception/${eventId}?${params}`
    );
  };

  return {
    getUsers,
    userStore,
    userSituationUpdate,
    userPasswordUpdate,
    userEmailUpdate,
    getProfiles,
    getUser,
    userUpdate,
    getUserForEntrance,
    updateUserForEntrance,
    getUserByEventId,
  };
};
